/** 用 canvas 实测字体行高（fontBoundingBox 优先，降级 actualBoundingBox），单位 px */
export const measureFontLineHeight = (fontSize: string, fontFamily?: string): number | undefined => {
    try {
        const canvas = document.createElement('canvas')
        const ctx = canvas.getContext('2d')
        if (!ctx) return undefined
        ctx.font = `400 ${fontSize} ${fontFamily || 'sans-serif'}`
        const m = ctx.measureText('Mg|jQ') as TextMetrics & {
            fontBoundingBoxAscent?: number
            fontBoundingBoxDescent?: number
        }
        const ascent = m.fontBoundingBoxAscent ?? m.actualBoundingBoxAscent
        const descent = m.fontBoundingBoxDescent ?? m.actualBoundingBoxDescent
        return Math.ceil(ascent + descent)
    } catch {
        return undefined
    }
}
